// src/features/landing/components/CategoryTabs.jsx
"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import { useAuth } from "../../../context/AuthContext";
import { toast } from "react-toastify";

export default function CategoryTabs({ selected, onSelect }) {
  const { user } = useAuth();
  const pathname = usePathname();

  const categories = [
    { key: "vouchers", label: "🎁 Digital Cards", href: "/vouchers" },
    { key: "topups",   label: "📱 Top-Ups",       href: "/topups" },
    { key: "esims",    label: "🛰️ eSIMs",        href: "/esims" },
    // keep ebooks special (or link it too)
    { key: "ebooks",   label: "📚 Ebooks",       href: "/ebooks" },
  ];

  return (
    <div className="flex gap-2 sm:gap-3 overflow-x-auto whitespace-nowrap pb-2">
      <div className="inline-flex bg-surface/80 border border-border rounded-full p-1 shadow-sm shadow-black/40">
        {categories.map(({ key, label, href }) => {
          // Use URL as source of truth when possible
          const isActive =
            pathname === href ||
            selected === key;

          // If you still want the SPA behavior on homepage, you can keep onSelect:
          const handleClick = (e) => {
            // Optional: keep your existing onSelect behavior (for homepage tabs)
            // but still navigate for crawlable URLs
            if (key === "ebooks") return; // let link do it
            onSelect?.(key);
          };

          return (
            <Link
              key={key}
              href={href}
              onClick={handleClick}
              className={`
                inline-flex items-center justify-center min-h-[44px] px-4 sm:px-5 rounded-full text-xs sm:text-sm font-semibold
                whitespace-nowrap transition-all duration-150
                focus:outline-none focus-visible:ring-2 focus-visible:ring-primary/80
                focus-visible:ring-offset-2 focus-visible:ring-offset-background
                ${
                  isActive
                    ? "bg-primary text-white shadow-sm"
                    : "text-textPrimary hover:bg-background/70"
                }
              `}
            >
              {label}
            </Link>
          );
        })}
      </div>
    </div>
  );
}
